if (!customElements.get('giveaway-countdown')) {
  customElements.define('giveaway-countdown', class extends HTMLElement {
    connectedCallback() {
      this.endsAt = Date.parse(this.dataset.dropAt);
      if (!Number.isFinite(this.endsAt)) return;
      this.paint = () => {
        const seconds = Math.max(0, Math.ceil((this.endsAt - Date.now()) / 1000));
        const values = { days: Math.floor(seconds / 86400), hours: Math.floor(seconds / 3600) % 24, minutes: Math.floor(seconds / 60) % 60, seconds: seconds % 60 };
        for (const [unit, value] of Object.entries(values)) {
          const node = this.querySelector(`[data-drop-unit="${unit}"]`);
          if (node) node.textContent = String(value).padStart(2, '0');
        }
        const timer = this.querySelector('[data-drop-timer]');
        if (timer) {
          timer.hidden = seconds === 0;
          // The inline flex layout must also be removed when the timer expires.
          timer.style.display = seconds === 0 ? 'none' : 'flex';
          timer.setAttribute('aria-label', `${values.days} days, ${values.hours} hours, ${values.minutes} minutes, ${values.seconds} seconds until the giveaway`);
        }
        const status = this.querySelector('[data-drop-status]');
        if (status) status.hidden = seconds > 0;
        if (seconds === 0) clearInterval(this.interval);
      };
      this.paint();
      if (Date.now() < this.endsAt) this.interval = setInterval(this.paint, 1000);
    }
    disconnectedCallback() { clearInterval(this.interval); }
  });
}
